import { createSelector } from 'reselect';
export var getFeatures = createSelector(function (state) {
  return state.getIn(['features']);
}, function (features) {
  return features ? features.toJS() : [];
});